import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/bell-filled/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/bell-filled/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/bell-filled/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconBellFilled24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Bell`, id: 'icon.title.bell-filled', comment: 'Title for bell filled icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-bell-filled-24-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" fill-rule="evenodd" d="M7.068 20.346a.75.75 0 0 1 .662-.14l3.85 1.032a.75.75 0 0 1 .44 1.126 2.86 2.86 0 0 1-3.133 1.224 2.86 2.86 0 0 1-2.1-2.627.75.75 0 0 1 .28-.615Zm8.568-19.019A.75.75 0 1 0 14.187.94l-.397 1.483C9.618 1.714 5.487 4.429 4.388 8.53c-.818 3.052-1.697 4.91-2.35 5.99a7.6 7.6 0 0 1-.775 1.085 3 3 0 0 1-.23.235l-.002.002a.75.75 0 0 0 .27 1.314l17.386 4.658a.75.75 0 0 0 .826-1.128l-.002-.004a1 1 0 0 1-.06-.163c-.056-.185-.131-.533-.155-1.109-.047-1.156.116-3.198 1.03-6.61 1.106-4.129-1.092-8.517-5.087-9.992l.397-1.482Z" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('w-icon-bell-filled-24')) {
  customElements.define('w-icon-bell-filled-24', IconBellFilled24);
}